export const Loading = () => {
  return (
    <div style={{textAlign: 'center'}}>
      <strong>Der Fragebogen wird geladen</strong>
    </div>
  );
}